import { loginTo } from "../utils/loginTo";
import { config } from "../app/config";
import Auth from "../services/auth";

import { create } from "apisauce";

const fetchExternalAuth = async (externalURL, email, password, clearance) => {
  const headers = {
    "X-Requested-With": "XMLHttpRequest",
    authorization: `Basic ${btoa(
      `${email.toUpperCase()}:${password.toUpperCase()}`
    )}`,
    ip: JSON.stringify(Auth.ipClient),
  };
  if (clearance) headers.clearance = clearance;

  return await create({
    baseURL: `${externalURL}/api/authentication/`,
    headers,
  }).post();
};

const login = async (
  classificacaoInstituicao,
  type,
  email,
  password,
  clearance
) => {
  if (config.all.isDev) {
    const { data, status } = await fetchExternalAuth(
      loginTo[config.all.validateEnvironment](),
      email,
      password,
      clearance
    );

    return { data, status };
  }

  if (config.all.validateEnvironment === "HOMOLOG") {
    const { data, status } = await fetchExternalAuth(
      loginTo[config.all.validateEnvironment](
        type,
        config.all.validateEnvironmentNumber
      ),
      email,
      password,
      clearance
    );

    return { data, status };
  }

  if (config.all.validateEnvironment === "IMPLANTACAO") {
    const { data, status } = await fetchExternalAuth(
      loginTo[config.all.validateEnvironment](type),
      email,
      password,
      clearance
    );

    return { data, status };
  }

  if (config.all.validateEnvironment === "PRODUCTION") {
    const { data, status } = await fetchExternalAuth(
      loginTo[classificacaoInstituicao](),
      email,
      password,
      clearance
    );

    return { data, status };
  }
};

const fetchExternalSelect = async (
  externalURL,
  convenioId,
  authToken,
  email,
  password,
  clearance
) => {
  const headers = {
    "X-Requested-With": "XMLHttpRequest",
    authorization: `Basic ${btoa(
      `${email.toUpperCase()}:${password.toUpperCase()}`
    )}`,
    ip: JSON.stringify(Auth.ipClient),
    "X-Auth-Token": authToken,
  };
  if (clearance) headers.clearance = clearance;

  return await create({
    baseURL: `${externalURL}/api/authentication/`,
    withCredentials: true,
    headers,
  }).post(`/contexts/select/redirect/${convenioId}`);
};

const select = async (
  convenioId,
  authToken,
  type,
  classificacaoInstituicao,
  email,
  password,
  clearance
) => {
  if (config.all.isDev) {
    const response = await fetchExternalSelect(
      loginTo[config.all.validateEnvironment](),
      convenioId,
      authToken,
      email,
      password,
      clearance
    );

    return response;
  }

  if (config.all.validateEnvironment === "HOMOLOG") {
    const response = await fetchExternalSelect(
      loginTo[config.all.validateEnvironment](
        type,
        config.all.validateEnvironmentNumber
      ),
      convenioId,
      authToken,
      email,
      password,
      clearance
    );

    return response;
  }

  if (config.all.validateEnvironment === "IMPLANTACAO") {
    const response = await fetchExternalSelect(
      loginTo[config.all.validateEnvironment](type),
      convenioId,
      authToken,
      email,
      password,
      clearance
    );

    return response;
  }

  if (config.all.validateEnvironment === "PRODUCTION") {
    const response = await fetchExternalSelect(
      loginTo[classificacaoInstituicao](),
      convenioId,
      authToken,
      email,
      password,
      clearance
    );

    return response;
  }
};

const ExternalAuth = { login, select };

export default ExternalAuth;
